import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface VendorResponse {
    ven_id?: number | null;
    ven_accno?: string | null;
    ven_code?: string | null;
    ven_Name?: string | null;
    ven_titile?: string | null;
    ven_crdate?: string | null;
    ven_crby?: string | null;
    ven_mddate?: string | null;
    ven_mdby?: string | null;
    ven_groupid?: string | null;
    ven_active?: boolean | number | null;
    ven_add1?: string | null;
    ven_add2?: string | null;
    ven_add3?: string | null;
    ven_add4?: string | null;
    ven_tep1?: string | null;
    ven_tep2?: string | null;
    ven_email?: string | null;
    ven_contact?: string | null;
    ven_reordercycle?: number | null;
    ven_creditlimit?: number | null;
    ven_creditperiod?: number | null;
    ven_opbal?: number | null;
    ven_purchase?: number | null;
    ven_returns?: number | null;
    ven_creditnote?: number | null;
    ven_debitnote?: number | null;
    ven_payment?: number | null;
    ven_balance?: number | null;
    ven_taxregno?: string | null;
    ven_latitude?: string | null;
    ven_longitude?: string | null;
}

export type VendorCreateUpdateRequest = Omit<VendorResponse, "ven_id" | "ven_crdate" | "ven_crby" | "ven_mddate" | "ven_mdby">;

export const getAllVendors = async (): Promise<VendorResponse[]> => {
    try {
        const response: ApiResponse<VendorResponse[] | null> = (
            await apiClient.get("/pos_vendor/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load vendors. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch vendors");
    }
};

export const createVendor = async (vendorData: VendorCreateUpdateRequest): Promise<{ ven_id: number }> => {
    try {
        const response: ApiResponse<{ ven_id: number }> = (
            await apiClient.post("/pos_vendor/create", vendorData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to create vendor");
    }
};

export const updateVendor = async (venId: number, vendorData: VendorCreateUpdateRequest): Promise<{ ven_id: number }> => {
    try {
        const response: ApiResponse<{ ven_id: number }> = (
            await apiClient.put(`/pos_vendor/update/${venId}`, vendorData, {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data;
    } catch (error: any) {
        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to update vendor");
    }
};
